import { Injectable } from '@angular/core';
import { mergeMap } from 'rxjs/operators';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { IntegrationIReckonHotelsAndUnitsService } from '@era/locations-sdk';
import {
  IReckonIntegrationResolverActions,
  IntegrationApiActions,
  IReckonIntegrationContainerActions,
} from './integrated-ireckon-room.actions';
import { safeMap } from '../effects.helpers';

@Injectable()
export class IntegratedIReckonRoomEffects {
  constructor(
    private readonly actions$: Actions,
    private readonly api: IntegrationIReckonHotelsAndUnitsService
  ) {}

  integrationsLoadedEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(IReckonIntegrationResolverActions.iReckonIntegrationRequested),
      mergeMap(({ roomUniqueId }) =>
        safeMap(
          this.api.getIntegratedIReckonRooms(undefined, undefined, undefined, roomUniqueId),
          (rooms) => IntegrationApiActions.iReckonIntegrationsLoaded({ rooms }),
          (error) => IntegrationApiActions.iReckonIntegrationsLoadedError({ error })
        )
      )
    );
  });

  integrationUpdateEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(IReckonIntegrationContainerActions.iReckonIntegrationUpdated),
      mergeMap(({ room }) =>
        room.id // existing room
          ? safeMap(
              this.api.updateIntegratedIReckonRoom(room.id, room),
              () => IntegrationApiActions.iReckonIntegrationUpdated({ room }),
              (error) => IntegrationApiActions.iReckonIntegrationUpdatedError({ room, error })
            )
          : safeMap(
              this.api.addIntegratedIReckonRoom(room),
              () => IntegrationApiActions.iReckonIntegrationAdded({ room }),
              (error) => IntegrationApiActions.iReckonIntegrationAddedError({ room, error })
            )
      )
    );
  });

  integrationDeletedEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(IReckonIntegrationContainerActions.iReckonIntegrationDeleted),
      mergeMap(({ room }) =>
        safeMap(
          this.api.deleteIntegratedIReckonRoom(room.id),
          () => IntegrationApiActions.iReckonIntegrationDeleted({ room }),
          (error) => IntegrationApiActions.iReckonIntegrationDeletedError({ room, error })
        )
      )
    );
  });
}
